<template>
    <div v-cloak>
        <div class="newheight"></div>
        <div class="an-box" v-if="question[index]">
            <div class="tilte">{{index+1}}.【{{question[index].questionTypeName}}】{{question[index].content}}
            </div>
            <div class="an-list" v-for="(item,key) of question[index].answerList" :key="item.id" @click="choose(key)">
                <div :class="'an '+(ask.includes(key)?'cur':'')">
                    <label :class="ask.includes(key)?'on':''"></label>{{item.answerNo}}.{{item.answerContent}}
                </div>
                <div class="an-img" v-if="item.picUrl">
                    <div class="imgs"><img :src="imgprefix+item.picUrl"></div>
                </div>
            </div>
            <div style="height:120px"></div>
            <div class="an-bottom">
                <label>{{index+1}}/{{question.length}}</label>
                <a href="javascript:void(0);" @click="next_step">{{(index+1)==question.length?'提交回答':'下一题'}}</a>
            </div>
        </div>
    </div>
</template>

<script>
    import {Toast} from 'mint-ui';

    export default {
        name: "question",
        data() {
            return {
                courseId: this.$route.query.courseId,
                author: this.$route.query.author,//孩子姓名
                question: [],//问题数组
                index: 0,//当前问题索引
                imgprefix: C.imgprefix,
                ask: [],//当前题目勾选回答索引数组
                answerList: [],//回答数组
            };
        },
        created() {
            this.get_question_list()
        },
        methods: {
            //获取问题数组
            get_question_list: function () {
                R.Ask.getQuestionList({courseId: this.courseId}).then(result => {
                    this.question = result
                })
            },

            //选择回答
            choose: function (key) {
                let index = this.ask.indexOf(key)
                if (this.question[this.index].questionType == 2) {//多选题
                    if (index == -1) {//未选中
                        this.ask.push(key)
                    } else {//已选中
                        this.ask.splice(index, 1)
                    }
                } else {//单选或判断题
                    this.ask = [key]
                }
            },

            //切换下一题
            next_step: function () {
                if (this.ask.length == 0) {
                    Toast('请选择回答')
                    return
                }
                let question = this.question[this.index],
                    item = {
                        questionId: question.id,
                    }, answerNo = []
                this.ask.forEach(value => {
                    answerNo.push(question.answerList[value].answerNo)
                })

                item.answerNo = answerNo.join(',')
                this.answerList.push(item)
                if ((this.index + 1) == this.question.length) {//最后一题，提交
                    this.commit()
                    return
                }
                this.ask = []//清空选项
                this.index++
            },

            //提交计算分数
            commit: function () {
                let courseId = this.courseId,
                    author = this.author,
                    answerList = JSON.stringify(this.answerList)
                R.Ask.calculatedFraction({courseId: this.courseId, answerList: this.answerList}).then(result => {
                    this.$router.replace(`/ask/result?result=${result}&courseId=${courseId}&author=${author}&answerList=${answerList}`)
                })
            }
        }
    }
</script>

<style scoped>
    .nav {
        height: 48px;
        padding-top: 20px;
        width: 100%;
        position: fixed;
        top: 0;
        text-align: center;
        display: flex;
        flex-direction: row;
        z-index: 9999;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        line-height: 24px;
        margin: 0;
        padding: 0;
        font-weight: 600;
    }

    .newheight {
        height: 48px;
    }

    .an-box {
        padding: 0 30px;
    }

    .tilte {
        font-size: 17px;
        color: #000000;
        font-weight: bold;
        padding-top: 30px;
        margin-bottom: 35px;
    }

    .an {
        height: 32px;
        border-radius: 100px;
        line-height: 32px;
        padding: 0 15px;
        margin-bottom: 15px;
        font-size: 14px;
        color: #666666
    }

    .an label {
        display: inline-block;
        width: 14px;
        height: 14px;
        background: url(/img/off.png) center center;
        background-size: 14px;
        position: relative;
        top: 2px;
        margin-right: 6px;
    }

    .an label.on {
        background: url(/img/on.png) center center;
        background-size: 14px;
    }

    .an-list .cur {
        background: #ebebeb;
        color: #000000;
    }

    .an-bottom {
        position: fixed;
        bottom: 36px;
        text-align: center;
        width: 100%;
        left: 0px;
    }

    .an-bottom text {
        font-size: 14px;
        color: #000;
        display: block;
        text-align: center;
    }

    .an-bottom a {
        display: block;
        width: 210px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 18px;
        color: #FFF;
        font-weight: bold;
        background: #FFC71C;
        border-radius: 100px;
        margin: 0 auto;
        margin-top: 15px;
    }

    .an-img {
        height: 84px;
        padding-left: 36px;
    }

    .imgs {
        float: left;
        margin-right: 10px;
        height: 84px;
        border-radius: 3px;
        overflow: hidden
    }

    .imgs img {
        height: 84px;
    }

    .an {
        margin-bottom: 10px;
        margin-top: 10px;
    }
</style>
